import {Category} from "scenes/cohort-filters/filter-configs/categories";
import {WidgetType} from "scenes/cohort-filters/filter-configs/widgetTypes";

export const switchFieldConstructor = ({
                                           pathToValue,
                                           category = Category.OTHER, label,
                                           nestedComponent = false,
                                           getValue,
                                           setValue,
                                           explicitFieldType,
                                           mustNotOnBang
                                       }) => ({
    [pathToValue]: {
        widgetType: WidgetType.SWITCH,
        category: nestedComponent ? undefined : category,
        defaultRuleProperties: {
            value: setValue ? setValue(true) : true,
            explicitFieldType,
            mustNotOnBang
        },
        widgetConfig: {
            label: label,
            getValue,
            setValue
        },
    },
});
